import React from 'react';
import style from './style.scss';

const Html = (props) => {
    const { field } = props;
    return (
        <div>
            <label
                 htmlFor={field.elementId}
                className={style.formLabel} 
            >
                {field.label}
            </label>
            <div dangerouslySetInnerHTML={{ __html: field.value }}  />
        </div>
    );
};

export default Html;
